
import { BasicButton } from "@goodgamestudios/asset-globals";
import { BasicStandardYesNoDialogProperties } from "@goodgamestudios/core";
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { Balancing } from "../../../constants/shared/Balancing";
import { Poker2GiveChipsEvent } from "../../../event/Poker2GiveChipsEvent";
import { AvatarVO } from "../../../gamevo/AvatarVO";
import { SeatVO } from "../../../gamevo/SeatVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2GiveChipsConfigDialogProperties } from "../giveChipsConfig/Poker2GiveChipsConfigDialogProperties";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2ReportPlayerDialogProperties } from "../Poker2ReportPlayerDialogProperties";
import { Poker2TableAvatarDialogProperties } from "./Poker2TableAvatarDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2TableAvatarDialog extends Poker2Dialog {
    public static NAME: string = "Poker2TableAvatarDialog";

    constructor(disp: Container) {
        super(disp);

        this.hasLightBoxBehaviour = true;
    }

    protected init(): void {
        super.init();

        this.controller.addEventListener("chipsSent", this.bindFunction(this.onChipsSent));

        this.avatarDialog.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
    }

    protected applyProperties(): void {
        this.updateAvatar(this.avatarProperties.avatarCardVO.avatar);
        this.avatarDialog.txt_rankname.text = Poker2Model.userData.generateTitle(this.avatarProperties.avatarCardVO.level);

        if (this.avatarProperties.avatarCardVO.id != Poker2Model.userData.playerID) {
            var isSocialBuddy: boolean = Poker2Model.buddyList.isSocialBuddyByPlayerId(this.avatarProperties.avatarCardVO.id);
            this.avatarDialog.btn_removefriend.visible = Poker2Model.buddyList.isBuddyByPlayerId(this.avatarProperties.avatarCardVO.id) || isSocialBuddy;
            this.avatarDialog.btn_removefriend.enableButton = !isSocialBuddy;
            this.avatarDialog.btn_addfriend.enableButton = !this.avatarProperties.isGuest && !Poker2Model.userData.isGuest();
            this.avatarDialog.btn_addmoney.enableButton = !Poker2Model.userData.isGuest() && this.avatarProperties.avatarCardVO.avatar.allowGiveChips;
            this.avatarDialog.btn_report.enableButton = true;
            this.avatarDialog.btn_ban.enableButton = true;
        }
        else {
            this.avatarDialog.btn_addmoney.enableButton = false;
            this.avatarDialog.btn_addfriend.enableButton = false;
            this.avatarDialog.btn_removefriend.visible = false;
            this.avatarDialog.btn_ban.enableButton = false;
            this.avatarDialog.btn_report.enableButton = false;
        }

        this.avatarDialog.btn_removefriend.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_removeBuddy");
        this.avatarDialog.btn_addfriend.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_addBuddy");

        // adjust tooltip text
        if (this.avatarDialog.btn_addmoney.enabled || (this.avatarProperties.avatarCardVO.id == Poker2Model.userData.playerID)) {
            this.avatarDialog.btn_addmoney.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_sendChips");
        }
        else {
            this.avatarDialog.btn_addmoney.toolTipText = Poker2Model.languageData.getTextById("dialog_profilcard_sendChips_inactiveTooltip");
        }

        if (!Poker2Model.sessionData.isOnIgnorList(this.avatarProperties.avatarCardVO.id))
            this.avatarDialog.btn_ban.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_blockBuddy");
        else
            this.avatarDialog.btn_ban.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_unblockBuddy");
        this.avatarDialog.btn_report.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_reportBuddy");
        this.avatarDialog.btn_statistics.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_statistic");

        this.avatarDialog.txt_name.text = this.avatarProperties.avatarCardVO.name;
        this.avatarDialog.mc_xp.txt_level.text = NumberStringHelper.groupString(this.avatarProperties.avatarCardVO.level, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.avatarDialog.txt_chips.text = NumberStringHelper.groupString(this.avatarProperties.avatarCardVO.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
    }

    private updateAvatar(avatarVO: AvatarVO): void {
        while (this.avatarDialog.mc_avatar.numChildren > 0)
            this.avatarDialog.mc_avatar.removeChildAt(0);
        /// var mcAvatar:Sprite = AvatarHelper.drawAvatarByItemArray( Poker2Model.avatarData.getAvatarClothesArray( avatarVO ));
        var mcAvatar: Container = new AvatarHolder(avatarVO);
        var bounds: Rectangle = mcAvatar.getBounds(null);

        var scaleFactor: number = (240 / bounds.width);

        if ((bounds.height * scaleFactor) > 240)
            scaleFactor = (240 / bounds.height);
        mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
        mcAvatar.x = -((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        mcAvatar.y = -((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));

        this.avatarDialog.mc_avatar.addChild(mcAvatar);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        var paramObject: any;

        if (event.target instanceof BasicButton && !(event.target as BasicButton).enabled)
            return;

        switch (event.target) {
            case this.avatarDialog.btn_close:
                this.hide();
                break;
            case this.avatarDialog.btn_addmoney:

                var chipsPerDay: number = 250;
                if ((this.env.loginIsKeyBased && Poker2Model.buddyList.isSocialBuddyByPlayerId(this.avatarProperties.avatarCardVO.id)) || (!this.env.loginIsKeyBased && Poker2Model.buddyList.isBuddyByPlayerId(this.avatarProperties.avatarCardVO.id))) {
                    chipsPerDay = 1000;
                }

                // open give chips configuration dialog (allows to control how much chips the user want to send)
                this.layoutManager.showDialog("Poker2GiveChipsConfigDialog", new Poker2GiveChipsConfigDialogProperties(this.avatarProperties.avatarCardVO.id, chipsPerDay, this.avatarProperties.avatarCardVO.name));
                this.hide();
                break;
            case this.avatarDialog.btn_addfriend:
                var index: number = int(Poker2Model.onTableData.getSeatIndexByPlayerId(this.avatarProperties.avatarCardVO.id));
                var mySeatVO: SeatVO = Poker2Model.onTableData.getSeatVOByIndex(index);
                if (mySeatVO && mySeatVO.stateGame == 7) {
                    this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("dialog_profilecard_wait")));
                }
                else {
                    Poker2Model.buddyList.isFriendshipRequested = true;
                    paramObject = { status: 0, offerPID: Poker2Model.userData.playerID, receivePID: this.avatarProperties.avatarCardVO.id };
                    BasicModel.smartfoxClient.sendMessage("big", [JSON.stringify(paramObject)]);
                }
                this.hide();
                break;
            case this.avatarDialog.btn_removefriend:
                this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("dialog_profilecard_removeBuddy"), Poker2Model.languageData.getTextById("dialog_removeBuddy_copy", [this.avatarProperties.avatarCardVO.name]), this.bindFunction(this.removeFriend)));
                break;
            case this.avatarDialog.btn_ban:
                Poker2Model.sessionData.addToIgnorList(this.avatarProperties.avatarCardVO.id);
                /*					if (!Poker2Model.sessionData.isOnIgnorList(avatarProperties.avatarCardVO.id))
                                        avatarDialog.btn_ban.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_blockBuddy");
                                    else
                                        avatarDialog.btn_ban.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_unblockBuddy");*/
                this.hide();
                break;
            case this.avatarDialog.btn_report:
                this.layoutManager.showDialog("Poker2ReportPlayerDialog", new Poker2ReportPlayerDialogProperties(this.avatarProperties.avatarCardVO.id, this.avatarProperties.avatarCardVO.name));
                break;
            case this.avatarDialog.btn_statistics:
                paramObject = { id: this.avatarProperties.avatarCardVO.id };
                BasicModel.smartfoxClient.sendMessage("gpp", [JSON.stringify(paramObject)]);
                break;
        }
    }

    protected onChipsSent(event: Event): void {
        this.avatarDialog.btn_addmoney.enableButton = false;
    }

    private removeFriend(params: any[]): void {
        var paramObject: any = { status: 3, offerPID: Poker2Model.userData.playerID, receivePID: this.avatarProperties.avatarCardVO.id };
        BasicModel.smartfoxClient.sendMessage("big", [JSON.stringify(paramObject)]);
        this.hide();
    }

    public destroy(): void {
        super.destroy();
        this.controller.removeEventListener("chipsSent", this.bindFunction(this.onChipsSent));
    }

    protected get avatarProperties(): Poker2TableAvatarDialogProperties {
        return this.properties as Poker2TableAvatarDialogProperties;
    }

    protected get avatarDialog(): Library.PokerInterface.OnTableAvatarCard {
        return this.disp as Library.PokerInterface.OnTableAvatarCard;
    }
}
import { BIGCommand } from "../../../controller/commands/buddy/BIGCommand";
import { AvatarHolder } from "../../helper/AvatarHolder";
import { Poker2GiveChipsConfigDialog } from "../giveChipsConfig/Poker2GiveChipsConfigDialog";
import { Poker2ReportPlayerDialog } from "../Poker2ReportPlayerDialog";
import { Poker2StandardOkDialog } from "../Poker2StandardOkDialog";
import { Poker2StandardYesNoDialog } from "../Poker2StandardYesNoDialog";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";
